import { InAppFeedResponse } from "../../models/notifications.types";

import { getApiClient } from "@punchup/utils/apiRegistry";

export async function fetchInAppFeed(
  limit?: number
): Promise<InAppFeedResponse> {
  const params = limit ? `?limit=${limit}` : "";
  const response = await getApiClient().get<{ data: InAppFeedResponse }>(
    `/api/v2/user/notifications/feed${params}`
  );
  return response.data;
}

export async function markAllFeedNotificationsAsRead(): Promise<void> {
  await getApiClient().post("/api/v2/user/notifications/feed/read-all");
}

export async function markFeedNotificationAsRead(
  notificationId: string,
  location?: string
): Promise<void> {
  await getApiClient().post("/api/v2/user/notifications/read", {
    notification_id: notificationId,
    location,
  });
}
